/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "sensors";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface GpsSourcePb {
}

export enum GpsSourcePb_Enum {
  UNKNOWN = 0,
  UBLOX = 1,
  SEPTENTRIO_X5 = 2,
  AMCD = 3,
  UNRECOGNIZED = -1,
}

export function gpsSourcePb_EnumFromJSON(object: any): GpsSourcePb_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return GpsSourcePb_Enum.UNKNOWN;
    case 1:
    case "UBLOX":
      return GpsSourcePb_Enum.UBLOX;
    case 2:
    case "SEPTENTRIO_X5":
      return GpsSourcePb_Enum.SEPTENTRIO_X5;
    case 3:
    case "AMCD":
      return GpsSourcePb_Enum.AMCD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GpsSourcePb_Enum.UNRECOGNIZED;
  }
}

export function gpsSourcePb_EnumToJSON(object: GpsSourcePb_Enum): string {
  switch (object) {
    case GpsSourcePb_Enum.UNKNOWN:
      return "UNKNOWN";
    case GpsSourcePb_Enum.UBLOX:
      return "UBLOX";
    case GpsSourcePb_Enum.SEPTENTRIO_X5:
      return "SEPTENTRIO_X5";
    case GpsSourcePb_Enum.AMCD:
      return "AMCD";
    case GpsSourcePb_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseGpsSourcePb(): GpsSourcePb {
  return {};
}

export const GpsSourcePb = {
  encode(_: GpsSourcePb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GpsSourcePb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGpsSourcePb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GpsSourcePb {
    return {};
  },

  toJSON(_: GpsSourcePb): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GpsSourcePb>, I>>(base?: I): GpsSourcePb {
    return GpsSourcePb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GpsSourcePb>, I>>(_: I): GpsSourcePb {
    const message = createBaseGpsSourcePb();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
